import clsx, { type ClassValue } from 'clsx';
import React from 'react';
import classes from './StationRoot.module.scss';

export interface StationRootProps {
  className?: ClassValue;
}

export const StationRoot: React.FC<StationRootProps> = ({
  children,
  className,
}) => {
  return (
    <div className={clsx(classes.container, 'route-animations', className)}>
      {children}
    </div>
  );
};
